var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msgwrp"},[_c('div',{staticClass:"textmsg fileMsg"},[_c('a',{attrs:{"target":"_blank","href":_vm.data.filePath}},[_c('img',{attrs:{"src":require("../../assets/file.png"),"width":"24","height":"24"}}),_vm._v("\n      "+_vm._s(_vm.data.Text)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67175427","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/ChatMessageFile.vue
// module id = null
// module chunks = 